var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepsPngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1364",
    "data-name": "Group 1364",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.94,
    height: 58.469,
    viewBox: "0 0 45.94 58.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    width: 45.94,
    height: 58.469,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25580",
    "data-name": "Path 25580",
    d: "M80.237,58.469H42.875a2.317,2.317,0,0,1-2.314-2.314V2.314A2.317,2.317,0,0,1,42.875,0H73.867L82.55,8.683V56.155a2.317,2.317,0,0,1-2.314,2.314",
    transform: "translate(-36.61)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25581",
    "data-name": "Path 25581",
    d: "M0,226.554l4.515,4.008.3-4.008Z",
    transform: "translate(0 -204.488)",
    fill: "#214aa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25582",
    "data-name": "Path 25582",
    d: "M80.237,58.469H42.875a2.317,2.317,0,0,1-2.314-2.314V2.314A2.317,2.317,0,0,1,42.875,0H73.867L82.55,8.683V56.155a2.317,2.317,0,0,1-2.314,2.314M42.875,1.129A1.186,1.186,0,0,0,41.69,2.314V56.155a1.186,1.186,0,0,0,1.185,1.185H80.237a1.186,1.186,0,0,0,1.185-1.185v-47L73.4,1.129Z",
    transform: "translate(-36.61)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25583",
    "data-name": "Path 25583",
    d: "M381.27,12.71a2.6,2.6,0,0,0,2.6,2.6h5.757L381.27,6.953Z",
    transform: "translate(-344.134 -6.276)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 32.959,
    height: 13.827,
    transform: "translate(0 8.24)",
    fill: "#2d80b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25584",
    "data-name": "Path 25584",
    d: "M87.59,125.415h2.019c1.289,0,2.334.469,2.334,1.892,0,1.379-1.054,1.992-2.3,1.992h-.73v1.992H87.59Zm1.973,2.829c.73,0,1.081-.324,1.081-.937s-.4-.838-1.117-.838h-.613v1.775Z",
    transform: "translate(-79.059 -113.2)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25585",
    "data-name": "Path 25585",
    d: "M142.735,125.415H144.1l1.532,2.92.577,1.3h.036c-.054-.622-.162-1.451-.162-2.145v-2.073h1.262v5.875h-1.361l-1.532-2.929-.577-1.28h-.036c.054.649.162,1.433.162,2.127v2.082h-1.262Z",
    transform: "translate(-128.833 -113.2)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25586",
    "data-name": "Path 25586",
    d: "M201.4,127.387a2.844,2.844,0,0,1,2.866-3.082,2.536,2.536,0,0,1,1.847.766l-.694.847a1.558,1.558,0,0,0-1.108-.469c-.91,0-1.55.712-1.55,1.892,0,1.207.55,1.91,1.649,1.91a1.047,1.047,0,0,0,.631-.18v-1.009h-.973v-1.081h2.145v2.7a2.832,2.832,0,0,1-1.937.712,2.752,2.752,0,0,1-2.875-3.01",
    transform: "translate(-181.781 -112.198)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 3.031,
    height: 3.031,
    transform: "translate(20.398 28.557)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 3.031,
    height: 3.031,
    transform: "translate(26.461 28.557)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1056",
    "data-name": "Rectangle 1056",
    width: 3.031,
    height: 3.031,
    transform: "translate(32.524 28.557)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 3.031,
    height: 3.031,
    transform: "translate(17.367 31.589)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 3.031,
    height: 3.031,
    transform: "translate(23.43 31.589)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1059",
    "data-name": "Rectangle 1059",
    width: 3.031,
    height: 3.031,
    transform: "translate(29.493 31.589)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 3.031,
    height: 3.031,
    transform: "translate(20.398 34.62)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 3.031,
    height: 3.031,
    transform: "translate(26.461 34.62)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 3.031,
    height: 3.031,
    transform: "translate(32.524 34.62)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 3.031,
    height: 3.031,
    transform: "translate(17.367 37.652)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 3.031,
    height: 3.031,
    transform: "translate(23.43 37.652)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1065",
    "data-name": "Rectangle 1065",
    width: 3.031,
    height: 3.031,
    transform: "translate(29.493 37.652)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 3.031,
    height: 3.031,
    transform: "translate(20.398 40.683)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 3.031,
    height: 3.031,
    transform: "translate(26.461 40.683)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 3.031,
    height: 3.031,
    transform: "translate(32.524 40.683)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 3.031,
    height: 3.031,
    transform: "translate(17.367 43.715)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 3.031,
    height: 3.031,
    transform: "translate(23.43 43.715)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 3.031,
    height: 3.031,
    transform: "translate(29.493 43.715)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1072",
    "data-name": "Rectangle 1072",
    width: 3.031,
    height: 3.031,
    transform: "translate(20.398 46.746)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 3.031,
    height: 3.031,
    transform: "translate(26.461 46.746)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    width: 3.031,
    height: 3.031,
    transform: "translate(32.524 46.746)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 3.031,
    height: 3.031,
    transform: "translate(14.335 28.557)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1076",
    "data-name": "Rectangle 1076",
    width: 3.031,
    height: 3.031,
    transform: "translate(14.335 34.62)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1077",
    "data-name": "Rectangle 1077",
    width: 3.031,
    height: 3.031,
    transform: "translate(14.335 40.683)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1078",
    "data-name": "Rectangle 1078",
    width: 3.031,
    height: 3.031,
    transform: "translate(14.335 46.746)",
    fill: "#c9c9c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsPngIcon);
export default __webpack_public_path__ + "static/media/steps-png-icon.d784776d0febc7a045c36914e06fc84d.svg";
export { ForwardRef as ReactComponent };